<ng-container *ngIf="inProgressCourse">
  <ng-container *ngIf="enrollmentObservable | async; let enrollment">
    <ng-content *ngIf="!enrollment.state" select="[not-approved]"></ng-content>
  </ng-container>
  <ng-content *ngIf="!(enrollmentObservable | async)" select="[not-enrolled]"></ng-content>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-enrollment-status/course-enrollment-status.component.html